import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Style
import styles from './AddedIngredients.styl';
import { useSelector } from 'react-redux';

const cx = classNames.bind(styles);

AddedIngredients.defaultProps = {
  className: '',
  list: [],
  item: null,
};

AddedIngredients.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array,
  intl: PropTypes.object,
  item: PropTypes.object,
};

function AddedIngredients(props) {
  const { className, list, intl, item } = props;
  const currency = useSelector(state => state.city.userCity.currency);
  const isDrinks = +item?.category_id === 5;
  const isItSauce = type => type === intl.formatMessage({ id: 'sauce' });
  return (
    <div
      className={cx('AddedIngredients', className)}
      dangerouslySetInnerHTML={{
        __html: list
          .sort((a, b) => isItSauce(b.type) - isItSauce(a.type))
          .map(item => {
            const price = item?.price || null;
            const commonPrice = isDrinks && price ? `${price} ${currency.unit}` : '';
            return `+&nbsp;${item.name} ${commonPrice} ${item.count > 1 ? ` x${item.count}` : ''}`;
          })
          .join(', '),
      }}
    />
  );
}

export default injectIntl(AddedIngredients);
